import { useNavigate } from "react-router-dom";

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const useOpenWindow = () => {
  const navigate = useNavigate();
  const openWindow = (url: string) => {
    if (isInIframe()) {
      navigate(url);
    } else {
      window.open(url);
    }
  };
  return { openWindow };
};
